export default __webpack_public_path__ + "static/media/Ontraccr-Logo-B-1400x400.50fd21d3.png";